import React, { useMemo } from "react";
import { Link } from "react-router-dom";

const FooterBook = () => {
  const year = useMemo(() => new Date().getFullYear(), []);

  return (
    <footer className="content__footer content-width">
      <div className="brand">
        <Link to="./public/images/vpro_logo.png">
          <img src="/assets/images/vpro_logo.png" alt="Virtualpro" />
        </Link>
      </div>
      <div className="copyright">
        <span>
          <strong>XBooks™</strong> es una marca registrada de Lugnia S.A.S. Sus
          contenidos están protegidos por la normativa de propiedad intelectual
          y sujetos a licencias vigentes con proveedores editoriales. Queda
          prohibido su uso no autorizado.
        </span>
        <span>
          <strong> © {year}, Virtual Pro ®</strong>
        </span>
      </div>
    </footer>
  );
};

export default FooterBook;
